import { CircleCheck } from "lucide-react";
import React from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { BaseIntegrationDto, IntegrationName } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { useDisableIntegration } from "@src/api/integrations/disable-integration";
import { usePutIntegration } from "@src/api/integrations/put-integration";

interface IntegrationViewProps {
  name: IntegrationName;
  title?: string;
  config?: BaseIntegrationDto;
}

export const IntegrationView = ({
  name,
  title,
  config,
}: IntegrationViewProps) => {
  const putIntegration = usePutIntegration();
  const disableIntegration = useDisableIntegration();
  const theme = useTheme();
  const onEnableClick = (action: "new" | "delete") => {
    if (action === "new") {
      putIntegration.mutate({
        body: {
          name,
        },
        pathParams: undefined,
        queryParams: undefined,
      });
    } else if (config?.id) {
      disableIntegration.mutate({
        body: undefined,
        pathParams: {
          id: config?.id,
        },
        queryParams: undefined,
      });
    }
  };

  return (
    <Grid item>
      <IgPaper sx={{ boxShadow: "none" }}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item>
            <Grid container alignItems={"center"} columnSpacing={2}>
              {config?.enabled ? (
                <Grid item>
                  <CircleCheck size={24} color={theme.igIconColors.success} />
                </Grid>
              ) : null}
              <Grid item>
                <IgTypography
                  variant={"h3"}
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {title ?? name}
                </IgTypography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <IgButton
              variant={"contained"}
              loading={putIntegration.isPending || disableIntegration.isPending}
              onClick={() => onEnableClick(config?.enabled ? "delete" : "new")}
            >
              {config?.enabled ? "Disable" : "Enable"}
            </IgButton>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
